import { useRoutes } from "react-router-dom";
import routes from "./Route/Routes";
import { AuthProvider } from "./core/context/AuthContext";
import "animate.css/animate.compat.css";
import { createCssVarsFromTheme } from "./theme/DemoSiteTheme";

const App = () => {
  const route = useRoutes(routes);
  createCssVarsFromTheme();
  
  return (
    <>
      <AuthProvider>{route}</AuthProvider>
    </>
  );
};

export default App;
